import Link from 'next/link'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'

export default function Header() {
  const router = useRouter()
  const [menuOpen, setMenuOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [logoError, setLogoError] = useState(false) // Fallback के लिए state

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  const navLinks = [
    { href: '/', label: 'Home' },
    { href: '/create', label: 'Create Token' },
    { href: '/explore', label: 'Explore' },
  ]

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: 'rgba(10,10,15,0.85)',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      backdropFilter: 'blur(20px)',
    }}>
      <div style={{
        maxWidth: '1200px', margin: '0 auto',
        padding: '0 20px', height: '64px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>

        {/* Logo Section with Fallback */}
        <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '12px' }}>
          {!logoError ? (
            <img 
              src="https://vdscan.io/logo.png" 
              alt="Logo" 
              onError={() => setLogoError(true)}
              style={{
                height: '38px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          ) : (
            // Fallback Icon (अगर इमेज लोड न हो)
            <div style={{
              width: '34px', height: '34px', borderRadius: '10px',
              background: 'linear-gradient(135deg, #7c3aed, #06b6d4)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '16px', fontWeight: '800', color: 'white'
            }}>
              {isMobile ? 'VD' : 'V'}
            </div>
          )}

          {!isMobile && (
            <span style={{ fontWeight: '700', fontSize: '18px', color: '#e2e8f0' }}>
              VDC <span style={{ color: '#7c3aed' }}>Token Tools</span>
            </span>
          )}
        </Link>

        {/* Desktop Nav */}
        {!isMobile && (
          <nav style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {navLinks.map(link => (
              <Link key={link.href} href={link.href} style={{
                padding: '8px 18px', borderRadius: '8px',
                textDecoration: 'none', fontSize: '14px',
                background: router.pathname === link.href
                  ? 'linear-gradient(135deg, #7c3aed, #06b6d4)'
                  : 'transparent',
                color: router.pathname === link.href ? 'white' : '#94a3b8',
                transition: '0.3s'
              }}>
                {link.label}
              </Link>
            ))}

            <Link href="/create" style={{
              marginLeft: '8px', padding: '9px 20px',
              background: 'linear-gradient(135deg, #7c3aed, #06b6d4)',
              color: 'white', borderRadius: '10px',
              textDecoration: 'none', fontSize: '14px',
              fontWeight: '600',
              boxShadow: '0 4px 15px rgba(124, 58, 237, 0.3)'
            }}>
              🚀 Launch Token
            </Link>
          </nav>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <button onClick={() => setMenuOpen(!menuOpen)} style={{
            background: 'none', border: 'none',
            fontSize: '26px', color: '#fff', cursor: 'pointer'
          }}>
            {menuOpen ? '✕' : '☰'}
          </button>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobile && menuOpen && (
        <div style={{
          background: '#0f172a',
          padding: '10px 20px 20px',
          borderTop: '1px solid rgba(255,255,255,0.05)',
          animation: 'slideDown 0.3s ease-out'
        }}>
          {navLinks.map(link => (
            <Link key={link.href} href={link.href} onClick={() => setMenuOpen(false)} style={{
              display: 'block',
              padding: '14px 0',
              color: router.pathname === link.href ? '#7c3aed' : '#cbd5f5',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: router.pathname === link.href ? '700' : '400',
              borderBottom: '1px solid rgba(255,255,255,0.02)'
            }}>
              {link.label}
            </Link>
          ))}

          <Link href="/create" onClick={() => setMenuOpen(false)} style={{
            display: 'block',
            marginTop: '20px',
            padding: '12px',
            textAlign: 'center',
            background: 'linear-gradient(135deg, #7c3aed, #06b6d4)',
            borderRadius: '10px',
            color: 'white',
            textDecoration: 'none',
            fontSize: '15px',
            fontWeight: '700'
          }}>
            🚀 Launch Token
          </Link>
        </div>
      )}

      <style jsx>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </header>
  )
}